const elavonColorPalete = [
    '#0075c9',
    '#CC7830',
    '#9E54C0',
    '#339699',
    '#66738F',
    '#D367BD',
    '#6D7C4C',
    '#DD6367',
    '#7868CE',
    '#17A67B',
    '#3289C8',
    '#BE5407',
]

// blue theme
export const clientThemeBlue = {
    mainLayout: {
        backgroundColor: '#fafaf9',
        hover: {
            backgroundColor: '#253B95',
        },
    },
    topBar: {
        backgroundColor: '',
        contrastText: '',
        contrastLinkText: '#098fe2',
        userIcon: 'red',
        brandLogo: {
            maxWidth: '175px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#afafaf',
        },
    },
    sidebar: {
        fontSize: '14px',
        backgroundColor: '#333436',
        darkBackgroundColor: '#1f2024',
        sideMenuActive: {
            backgroundColor: '#0075c9',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#0075c9',
        stroke: '#0075c9',
        lineCharts: {
            stroke: '#0075c9',
            fill: '#0075c9',
        },
        areaCharts: {
            gradient: {
                start: '#0075c9',
                stop: '#0075c9',
            },
            stroke: '#0075c9',
            fill: '#0075c9',
            chargebacksByPostDateChart: {
                stroke: '#0075c9',
                fill: '#0075c9',
            },
            newAlertsByDateChart: [
                { stroke: '#014f8f', fill: 'rgba(1, 79, 143, 0.5)' },
                { stroke: '#0065b7', fill: '#0065b773' },
                { stroke: '#0075c9', fill: '#0075c9' },
                { stroke: '#0c87db', fill: '#0c87db7a' },
                { stroke: '#1595e9', fill: '#1595e97a' },
                { stroke: '#3ea4ec', fill: '#3ea4ec80' },
                { stroke: '#62b4ee', fill: '#62b4ee7d' },
            ],
        },
        barCharts: {
            fill: '#0075c9',
            byPlatformBarChart: { fill: '#0075c9' },
            byBinBarChart: { fill: '#0075c9' },
            ertsByRevenueChart: {
                bar1Fill: '#0075c9',
                bar2Fill: '#0c2074',
            },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#0075c9',
                lineColor: '#CC7830',
            },
        },
        heatmapCharts: {
            casesFiled: {
                low: '#0075c9',
                mid: '#9E54C0',
                high: '#CC7830',
            },
        },
        pieCharts: {
            defaultPieChart: elavonColorPalete,
            dashboardPieChart: elavonColorPalete,
            byReasonCodePieChart: elavonColorPalete,
            byReasonCodeDistributionPieChart: elavonColorPalete,
            byCardTypePieChart: elavonColorPalete,
            byLocationTypePieChart: elavonColorPalete,
            byPlatformPerCardTypePieChart: elavonColorPalete,
            byStatusPieChart: elavonColorPalete,
            byWinLossPieChart: elavonColorPalete,
        },

        radialBarCharts: {
            fill: '#0075c9',
        },
    },
    lockAndUnlockButton: {
        lockButton: {
            backgroundColor: '#253B95',
            '&:hover': {
                backgroundColor: '#253B95',
                color: '#161616',
                boxShadow: 'none',
            },
        },
        unlockButton: {
            backgroundColor: '#253B95',
            '&:hover': {
                backgroundColor: '#253B95',
                color: '#161616',
                boxShadow: 'none',
            },
        },
    },
    lampColors: {
        green: '#24874B',
        red: '#cb2022',
        orange: '#d87707',
        yellow: '#d8d800',
        grey: 'grey',
    },
    uploadDnD: {
        borderColor: `#253B95`,
        backgroundColor: `rgba(208,230,246,.4)`,
        labelColor: `#253B95`,
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#0075c9',
        saveAndContinueBtn: {},
        submittingColor: '#0075c9',
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '#253B95',
        borderRadius: '4px',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '7px 8px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#4C505B',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e0e0e0',
    },
    searchBar: {
        padding: '6px',
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#E0E0E0',
                color: 'rgba(0, 0, 0, 0.87)',
                '&:hover': {
                    backgroundColor: '#d5d5d5',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 600,
                padding: '4px 10px',
                fontSize: '14px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#4f4f4f',
                backgroundColor: '#D5D5D5',
                '&:hover': {
                    color: '#4f4f4f',
                    backgroundColor: '#D5D5D5',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#3ED4AF',
                '&:hover': {
                    backgroundColor: '#3ac5a2',
                },
            },
        },
        activeStateButton: {
            color: 'white',
            backgroundColor: '#61656E',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#0c2074',
    primaryLight: '#0075c9',
    primary: '#0c2074',
    primaryDark: '#091853',
    secondaryLight: '#0C88DB',
    secondary: '#0075c9',
    secondaryDark: '#0065B7',
    hyperlink: '#098fe2',
    textField: '#0c2074',
    switch: '#005EB8',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Roboto', 'sans-serif'],
        fontFamilyConfig: {
            primary: 'Roboto',
            fallback:
                '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Arial, sans-serif',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '16px',
        },
        h6: {
            fontSize: '14px',
        },
        subtitle1: {
            fontSize: '16px',
        },
        subtitle2: {
            fontSize: '14px',
        },
        subtitle3: {
            fontSize: '15px',
        },
        subtitle4: {
            fontSize: '14px',
        },
        body1: {
            fontSize: '14px',
        },
        body2: {
            fontSize: '12px',
        },
        button1: {
            fontSize: '14px',
        },
        button2: {
            fontSize: '13px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '14px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '14px',
                color: '#52525b',
            },
            tableExpandable: {
                fontSize: '14px',
            },
        },
    },
}
